import types from '../../realEstateTypes.js';

const BUY_SUB_TITLES = {
  priceSubTitle: 'Kaufpreis',
  priceTrendSubTitle: 'Kaufpreisentwicklung',
  activeListingsSubTitle: 'Kaufangebote',
};

const RENT_SUB_TITLES = {
  priceSubTitle: 'Mietpreis',
  priceTrendSubTitle: 'Mietpreisentwicklung',
  activeListingsSubTitle: 'Mietangebote',
};

const TYPE_CONFIG = {
  [types.HOUSE_BUY]: {
    title: 'Kaufpreise und Angebote von Häusern',
    ...BUY_SUB_TITLES,
  },
  [types.HOUSE_RENT]: {
    title: 'Mietpreise und Angebote von Häusern',
    ...RENT_SUB_TITLES,
  },
  [types.APARTMENT_BUY]: {
    title: 'Kaufpreise und Angebote von Wohnungen',
    ...BUY_SUB_TITLES,
  },
  [types.APARTMENT_RENT]: {
    title: 'Mietpreise und Angebote von Wohnungen',
    ...RENT_SUB_TITLES,
  },
};

const COSMA_TYPE_CONFIG = {
  [types.HOUSE_BUY]: {
    title: 'Kaufpreise und Angebote',
    realEstateType: 'von Häusern',
    ...BUY_SUB_TITLES,
  },
  [types.HOUSE_RENT]: {
    title: 'Mietpreise und Angebote',
    realEstateType: 'von Häusern',
    ...RENT_SUB_TITLES,
  },
  [types.APARTMENT_BUY]: {
    title: 'Kaufpreise und',
    realEstateType: 'Angebote von Wohnungen',
    ...BUY_SUB_TITLES,
  },
  [types.APARTMENT_RENT]: {
    title: 'Mietpreise und Angebote',
    realEstateType: 'von Wohnungen',
    ...RENT_SUB_TITLES,
  },
};

function getFor(realEstateType) {
  return TYPE_CONFIG[realEstateType] || TYPE_CONFIG[types.APARTMENT_BUY];
}

function getForCosma(realEstateType) {
  return COSMA_TYPE_CONFIG[realEstateType] || COSMA_TYPE_CONFIG[types.APARTMENT_BUY];
}

export default {
  getFor,
  getForCosma,
};
